import React from 'react';
const TripEditContext = React.createContext(null);
export default TripEditContext;
